import type { CSSProperties } from "react";
import React from "react";
import Image from "next/image";
import { formatCurrency, formatPercentage } from "utils/currencies/formatters";
import NextLink from "components/parts/NextLink";
import { Card } from "app/_components/components/Card";
import { Heading } from "app/_components/components/Text/Heading";

interface TrendingTokenCardProps {
  coinSymbol: string;
  coinPrice: string;
  coinImgUrl: string;
  coinChange: number;
  slug: string;
  cardStyles?: CSSProperties;
}

export const TrendingTokenCardComponent = (props: TrendingTokenCardProps) => {
  const { coinSymbol, coinPrice, coinImgUrl, coinChange, slug } = props;

  return (
    <NextLink newTab href={`https://www.gemini.com/prices/${slug}`}>
      <Card
        variant="outlined"
        padding="sm"
        isInteractive
        className="mx-auto flex !h-[168px] !w-[128px] flex-col justify-between"
        style={props.cardStyles ?? {}}
      >
        <div className="mb-6 text-left">
          {coinImgUrl && (
            <Image
              src={coinImgUrl}
              alt="coin name"
              width={40}
              height={40}
              className="rounded-full"
            />
          )}
          <Heading
            size="xs"
            className="small-desktop:!text-[16px] small-desktop:!leading-[24px] small-desktop:!font-semibold"
          >
            {coinSymbol}
          </Heading>
        </div>
        <div className="w-full text-left">
          <p className="text-sm leading-5 font-normal">
            {formatCurrency(coinPrice)}
          </p>
          <p
            className={`mt-1 text-sm leading-5 font-normal ${
              coinChange > 0 ? "text-[#0E8535]" : "text-[#CA3A3A]"
            }`}
          >
            {formatPercentage(coinChange)}
          </p>
        </div>
      </Card>
    </NextLink>
  );
};
